import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  CircularProgress,
  Button,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { fetchDataFromAPI } from "../components/api.js"; // Adjust import as necessary

const FAQs = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const itemsPerPage = 10; // You can modify this as needed

  // Function to fetch FAQs from the API
  const fetchData = async (page = 1, itemsPerPage = 10) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const queryParams = { page, limit: itemsPerPage };
      const queryString = new URLSearchParams(queryParams).toString();

      // Fetch FAQs from the API
      const { data: fetchedFaqs, pagination } = await fetchDataFromAPI(
        `/api/faqs`,
        queryString,
        token
      );

      setFaqs(fetchedFaqs || []);
      setTotalPages(pagination?.totalPages || 1);
    } catch (err) {
      setError("Error fetching FAQs");
      console.error("Error fetching FAQs:", err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(page, itemsPerPage); // Fetch FAQs on component mount and when page changes
  }, [page]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1); // Adjusting the page number as the pagination API uses 1-based index
  };

  return (
    <div
      style={{
        backgroundColor: "#F4F6F9", // Dashboard background
        minHeight: "100vh",
        padding: "20px",
      }}
    >
      <Typography
        variant="h4"
        style={{
          textAlign: "center",
          color: "#333333", // Dark gray text for the header
          marginBottom: "40px",
        }}
      >
        FAQs
      </Typography>

      {loading && <CircularProgress />}
      {error && <Typography color="error">{error}</Typography>}

      {/* Display FAQs in an Accordion format */}
      {!loading && !error && (
        <Box>
          {faqs.length === 0 ? (
            <Typography style={{ textAlign: "center", color: "#333333" }}>
              No FAQs available.
            </Typography>
          ) : (
            faqs.map((faq) => (
              <Accordion key={faq.id} style={{ marginBottom: "10px" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel-${faq.id}-content`}
                  id={`panel-${faq.id}-header`}
                  style={{
                    backgroundColor: "#FFFFFF", // White background for accordion header
                    border: "1px solid #D1D8E0", // Border for accordion
                  }}
                >
                  <Typography variant="h6" style={{ color: "#333333" }}>
                    {faq.question}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails style={{ backgroundColor: "#FFFFFF" }}>
                  <Typography style={{ color: "#333333" }}>
                    {faq.response}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))
          )}

          {/* Pagination */}
          {totalPages > 1 && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "20px",
              }}
            >
              <Button
                onClick={(e) => handleChangePage(e, page - 2)}
                variant="outlined"
                color="primary"
                style={{
                  marginRight: "10px",
                  backgroundColor: "#A6AAAD", // Muted grayish-blue for button
                  color: "#2E4053", // Dark blue text
                }}
              >
                Previous
              </Button>
              <Typography style={{ margin: "0 10px", color: "#333333" }}>
                {`Page ${page} of ${totalPages}`}
              </Typography>
              <Button
                onClick={(e) => handleChangePage(e, page)}
                variant="outlined"
                color="primary"
                style={{
                  marginLeft: "10px",
                  backgroundColor: "#A6AAAD", // Muted grayish-blue for button
                  color: "#2E4053", // Dark blue text
                }}
              >
                Next
              </Button>
            </Box>
          )}
        </Box>
      )}
    </div>
  );
};

export default FAQs;
